export enum PlaceOfMarriage {
  FINLAND = 'SUOMI',
  NORDICS = 'POHJOISMAAT',
  OTHER = 'MUU',
}
